export const WORKSPACE_AVATAR_COLORS = [
  'bg-lime-400',
  'bg-emerald-500',
  'bg-sky-500',
  'bg-violet-500',
  'bg-amber-400',
  'bg-rose-500',
  'bg-teal-500',
  'bg-indigo-500',
] as const;

export function resolveWorkspaceInitial(name: string): string {
  const trimmed = name.trim();
  return trimmed ? trimmed.charAt(0).toUpperCase() : 'W';
}

export function resolveWorkspaceAvatarClass(key: string): string {
  let hash = 0;

  for (let index = 0; index < key.length; index += 1) {
    hash += key.charCodeAt(index);
  }

  return WORKSPACE_AVATAR_COLORS[hash % WORKSPACE_AVATAR_COLORS.length];
}

export function formatFormsLabel(count: number): string {
  return count === 1 ? '1 form' : `${count} forms`;
}

export function formatWorkspaceRole(role: string): string {
  return role.charAt(0) + role.slice(1).toLowerCase();
}
